export function getInsuranceName(insurance) {
  if (insurance.is_placeholder) {
    return insurance.is_primary
      ? '[Primary Insurance]'
      : '[Secondary Insurance]'
  } else {
    return `${insurance.insurance_subscription.insurance_plan.insurance_company.carrier_name} (Insurance)`
  }
}
